// Copyright 2024 IOTA Stiftung.
// SPDX-License-Identifier: Apache-2.0.
/**
 * Options for the CLI Output for console.
 */
export interface ICliOutputOptionsConsole {
	/**
	 * Flag to display on the console.
	 */
	console: boolean;
}
